export function clearBranchName(branchName) {
    if (!branchName) {
        return '';
    }
    let branch = '';
    if (branchName.substring(0, 2) === 'b-') {
        branch = branchName.substring(2, branchName.length);
    }
    else if (branchName.substring(0, 3) === '/b-') {
        branch = branchName.substring(3, branchName.length);
    }
    const isPrefixPresent = branchName.substring(0, 2) === 'b-' || branchName.substring(0, 3) === '/b-';
    return isPrefixPresent ? branch : branchName;
}
export function replaceAsciiCharWithSlash(nameWithASCIIChar) {
    return nameWithASCIIChar.replace(/%2F/g, '/');
}
export function replaceSlashWithAsciiChar(name) {
    return name.replace(/\//g, '%2F');
}
export function resolveBranchName(activeBranchName, mainBranchName, isActiveBranchMain) {
    const branchName = activeBranchName ?? mainBranchName;
    if (!activeBranchName || !mainBranchName) {
        return branchName;
    }
    return activeBranchName !== mainBranchName
        ? `${!isActiveBranchMain ? '/b-' : ''}${replaceSlashWithAsciiChar(activeBranchName)}`
        : branchName;
}
